//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

const { FeatureNames } = require('@bvengineering/curalate-features');

(function () {
  const curalate = angular.module('curalate');

  curalate.component('sourcesDropdown', {
    bindings: {
      initialSources: '<',
    },
    template: require('@legacy-components/content/sources-dropdown/sources-dropdown.html'),
    controller: [
      '$element',
      '$sce',
      '$scope',
      '$modal',
      '$timeout',
      'InstagramAccountsService',
      'rx',
      'TrackedSourcesService',
      'UsersService',
      'SearchFilterNestedCheckboxService',
      'SearchFilterService',
      'SessionVarsService',
      'COLLECTION_SETTINGS',
      'CONTENT_LIBRARY_SOURCES_GROUPS',
      'SEARCH_FILTERS',
      'TrackingService',
      function (
        $element,
        $sce,
        $scope,
        $modal,
        $timeout,
        InstagramAccountsService,
        rx,
        TrackedSourcesService,
        UsersService,
        SearchFilterNestedCheckboxService,
        SearchFilterService,
        SessionVarsService,
        COLLECTION_SETTINGS,
        CONTENT_LIBRARY_SOURCES_GROUPS,
        SEARCH_FILTERS,
        TrackingService,
      ) {
        const self = this;
        const myUserId = SessionVarsService.getUserId().toString();
        const ngUnsubscribe = new rx.Subject();
        const SELECT_A_SOURCE = 'Add or Remove Sources';
        const MY_USER_SUFFIX = ' (You)';

        let allMediaCheckbox;
        let allInstagramCheckbox;
        let allPinterestCheckbox;
        let teamMediaCheckbox;
        let allTrackedUsersCheckbox;
        let allTrackedCompetitorsCheckbox;
        let allTrackedHashtagsCheckbox;
        let allDropboxCheckbox;
        let allFacebookCheckbox;
        let allTikTokCheckbox;
        let allYouTubeCheckbox;
        const TRACKING_CATEGORY = TrackingService.CATEGORY_LIBRARY;

        self.isDamImportDropboxEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.DamImportDropbox,
        );

        self.isLoading = true;
        self.sourcesLabel = SELECT_A_SOURCE;

        self.isTooltipDisabled = false;

        self.SEARCH_FILTER_SET_NAME =
          SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS;
        self.initialState = {
          sourcesGroups: [],
          curalateUserIds: [],
          trackedBusinessUserIds: [],
          trackedUserIds: [],
          trackedCompetitorIds: [],
          trackedHashtags: [],
          accountMentionIds: [],
          sources: [],
          brandFeedPost: [],
          brandStoryPost: [],
        };

        const transformUserModel = function (user) {
          const name = [user.firstName, user.lastName].join(' ').trim();
          return {
            id: user.id.toString(),
            name,
            nameLowerCased: name.toLowerCase(),
          };
        };

        const ensureNestedCheckboxExists = function (
          option,
          filterKey,
          optionValue,
          parent,
        ) {
          const existingCheckbox =
            SearchFilterNestedCheckboxService.getNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              filterKey,
              option[optionValue],
            );
          if (!existingCheckbox) {
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              filterKey,
              option[optionValue],
              parent,
            );
          }
        };

        const ensureNestedCheckboxesExist = function (
          options,
          filterKey,
          optionValue,
          parent,
        ) {
          _(options).each((option) => {
            ensureNestedCheckboxExists(option, filterKey, optionValue, parent);
          });
        };

        const handleUsersStateUpdate = function (usersState) {
          const users = usersState.users;
          self.curalateUsers = _(users).map(transformUserModel);
          ensureNestedCheckboxesExist(
            self.curalateUsers,
            COLLECTION_SETTINGS.FILTERS.CURALATE_USER_IDS,
            'id',
            teamMediaCheckbox,
          );
        };

        const handleTrackedSourcesStateUpdate = function (trackedSourcesState) {
          self.trackedBusinessUsers =
            trackedSourcesState.trackedSources.businessUsers;

          self.trackedRegularUsers = _(
            trackedSourcesState.trackedSources.users,
          ).filter((user) => {
            return !user.isTrackedBusinessUser;
          });

          self.trackedUsers = trackedSourcesState.trackedSources.users;

          ensureNestedCheckboxesExist(
            self.trackedBusinessUsers,
            COLLECTION_SETTINGS.FILTERS.TRACKED_BUSINESS_USER_IDS,
            'id',
            allTrackedUsersCheckbox,
          );
          ensureNestedCheckboxesExist(
            self.trackedRegularUsers,
            COLLECTION_SETTINGS.FILTERS.TRACKED_USER_IDS,
            'id',
            allTrackedUsersCheckbox,
          );

          self.trackedCompetitors =
            trackedSourcesState.trackedSources.competitors;
          ensureNestedCheckboxesExist(
            self.trackedCompetitors,
            COLLECTION_SETTINGS.FILTERS.TRACKED_COMPETITOR_IDS,
            'id',
            allTrackedCompetitorsCheckbox,
          );

          self.trackedHashtags = trackedSourcesState.trackedSources.hashtags;
          ensureNestedCheckboxesExist(
            self.trackedHashtags,
            COLLECTION_SETTINGS.FILTERS.TRACKED_HASHTAGS,
            'name',
            allTrackedHashtagsCheckbox,
          );
        };

        const handleInstagramAccountsStateUpdate = function (
          instagramAccountState,
        ) {
          self.defaultInstagramAccount =
            instagramAccountState.defaultInstagramAccount;
          if (self.defaultInstagramAccount) {
            ensureNestedCheckboxExists(
              self.defaultInstagramAccount,
              COLLECTION_SETTINGS.FILTERS.ACCOUNT_MENTION_IDS,
              'accountId',
              allInstagramCheckbox,
            );
            const allBrandInstagramCheckbox =
              SearchFilterNestedCheckboxService.addNestedCheckbox(
                self.SEARCH_FILTER_SET_NAME,
                COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
                CONTENT_LIBRARY_SOURCES_GROUPS.ALL_BRAND_POSTS,
                allInstagramCheckbox,
              );
            // 'brandFeedPost' and 'brandStoryPost' will be passed to ContentLibraryApi as Booleans, but we store them
            // as Arrays and push a dummy value onto them when we want them to be evaluated as true
            ensureNestedCheckboxExists(
              { value: 'true' },
              COLLECTION_SETTINGS.FILTERS.BRAND_FEED_POST,
              'value',
              allBrandInstagramCheckbox,
            );
            ensureNestedCheckboxExists(
              { value: 'true' },
              COLLECTION_SETTINGS.FILTERS.BRAND_STORY_POST,
              'value',
              allBrandInstagramCheckbox,
            );
          }
        };

        const handlePinterestAccountsStateUpdate = function () {
          if (SessionVarsService.getPinterestUserId()) {
            ensureNestedCheckboxExists(
              { id: SessionVarsService.getPinterestUserId() },
              COLLECTION_SETTINGS.FILTERS.PINTEREST_USER_IDS,
              'id',
              allPinterestCheckbox,
            );
          }
        };

        const materializeSourcesFromIds = function (
          ids,
          sources,
          key,
          prefix,
          isCuralateUserId,
        ) {
          const materializedSources = [];

          prefix = prefix || '';

          _(ids).each((id) => {
            const whereClause = {};
            whereClause[key] = id;

            const materializedSource = _(sources).findWhere(whereClause);
            if (materializedSource) {
              const suffix =
                isCuralateUserId && myUserId === id ? MY_USER_SUFFIX : '';
              materializedSources.push(
                prefix + materializedSource.name + suffix,
              );
            }
          });

          return materializedSources;
        };

        const computeSourceCount = function (sourceConfiguration) {
          return _.chain(sourceConfiguration)
            .pairs()
            .reduce((memo, pair) => {
              let memoCount;

              if (angular.isObject(memo)) {
                memoCount = memo[1].length;
              } else {
                memoCount = memo;
              }

              return memoCount + pair[1].length;
            })
            .value();
        };

        const computeSourcesDisplayTextFromConfiguration = function (
          sourceConfiguration,
        ) {
          let sources = [];

          const sourceCount = computeSourceCount(sourceConfiguration);

          if (
            sourceCount === 1 &&
            _(sourceConfiguration.sourcesGroups).contains(
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_MEDIA,
            )
          ) {
            sources.push('All Media');
          } else if (sourceConfiguration.sourcesGroups.length > 0) {
            _(sourceConfiguration.sourcesGroups).each((sourcesGroup) => {
              switch (sourcesGroup) {
                case CONTENT_LIBRARY_SOURCES_GROUPS.TEAM_MEDIA:
                  if (sourceConfiguration.curalateUserIds.length === 0) {
                    sources.push('Team Media');
                  }
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_HASHTAGS:
                  if (sourceConfiguration.trackedHashtags.length === 0) {
                    sources.push('Tracked Hashtags');
                  }
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_USERS:
                  if (sourceConfiguration.trackedUserIds.length === 0) {
                    sources.push('Tracked Users');
                  }
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_COMPETITORS:
                  if (sourceConfiguration.trackedCompetitorIds.length === 0) {
                    sources.push('Tracked Competitors');
                  }
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_INSTAGRAM:
                  sources.push('Instagram Media');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_PINTEREST:
                  sources.push('Pinterest Media');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_BRAND_POSTS:
                  sources.push('Instagram Account');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_DROPBOX:
                  sources.push('Dropbox Media');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TIKTOK:
                  sources.push('TikTok Media');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_FACEBOOK:
                  sources.push('Facebook Media');
                  break;
                case CONTENT_LIBRARY_SOURCES_GROUPS.ALL_YOUTUBE:
                  sources.push('YouTube Media');
                  break;
                default:
                  break;
              }
            });
          }

          sources = sources.concat(
            materializeSourcesFromIds(
              sourceConfiguration.curalateUserIds,
              self.curalateUsers,
              'id',
              '',
              true /* isCuralateUserId */,
            ),
          );
          sources = sources.concat(
            materializeSourcesFromIds(
              sourceConfiguration.trackedHashtags,
              self.trackedHashtags,
              'name',
              '#',
            ),
          );
          sources = sources.concat(
            materializeSourcesFromIds(
              sourceConfiguration.trackedUserIds,
              self.trackedUsers,
              'id',
              '@',
            ),
          );
          sources = sources.concat(
            materializeSourcesFromIds(
              sourceConfiguration.trackedCompetitorIds,
              self.trackedUsers,
              'id',
              '@',
            ),
          );
          sources = sources.concat(
            materializeSourcesFromIds(
              sourceConfiguration.trackedBusinessUserIds,
              self.trackedUsers,
              'id',
              '@',
            ),
          );

          if (
            sourceConfiguration.brandFeedPost &&
            sourceConfiguration.brandFeedPost.length > 0
          ) {
            sources.push('Instagram Feed Posts');
          }

          if (
            sourceConfiguration.brandStoryPost &&
            sourceConfiguration.brandStoryPost.length > 0
          ) {
            sources.push('Instagram Story Posts');
          }
          // Special case for 'Account Mentions'
          if (
            sourceConfiguration.accountMentionIds &&
            sourceConfiguration.accountMentionIds.length > 0
          ) {
            sources.push('Mentioned & Tagged');
          }

          if (
            sourceConfiguration.pinterestUserIds &&
            sourceConfiguration.pinterestUserIds.length > 0
          ) {
            sources.push('Pinterest Account');
          }

          return sources;
        };

        const trackOpenModal = function (label) {
          TrackingService.recordEvent(
            TRACKING_CATEGORY,
            TrackingService.ACTION_COLLECTIONS_SOURCES_VIEW_ALL,
            label,
          );
        };

        const computeSourcesSummary = function (sources) {
          const sourcesSummary = sources.join('; ');
          if (sources.length === 0) {
            self.sourcesLabel = SELECT_A_SOURCE;
            self.sourcesSummaryHtml = null;
          } else if (sources.length < 4 && sourcesSummary.length <= 35) {
            self.sourcesLabel = sourcesSummary;
            self.sourcesSummaryHtml = null;
          } else {
            self.sourcesLabel = `${sources.length} Sources`;
            self.sourcesSummaryHtml = $sce.trustAsHtml(
              `${
                '<div class="sources-dropdown-summary-popover-content">' +
                '<span style="font-weight: bold;">Selected Sources:</span><br/>'
              }<div class="sources-summary-block">${
                sourcesSummary
              }</div></div>`,
            );
          }
        };

        const updateSourcesLabelFromFilterUpdate = function (setUpdate) {
          const sourceConfiguration = setUpdate.setObject;
          const sources =
            computeSourcesDisplayTextFromConfiguration(sourceConfiguration);
          self.sourcesCount = sources.length;

          $scope.$applyAsync(() => {
            computeSourcesSummary(sources);
          });
        };

        const createTopLevelNestedCheckboxes = function () {
          allMediaCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_MEDIA,
            );
          allInstagramCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_INSTAGRAM,
              allMediaCheckbox,
            );
          allPinterestCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_PINTEREST,
              allMediaCheckbox,
            );
          teamMediaCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.TEAM_MEDIA,
              allMediaCheckbox,
            );
          allTrackedUsersCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_USERS,
              allInstagramCheckbox,
            );
          allTrackedCompetitorsCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_COMPETITORS,
              allInstagramCheckbox,
            );
          allTrackedHashtagsCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TRACKED_HASHTAGS,
              allInstagramCheckbox,
            );
          if (self.isDamImportDropboxEnabled) {
            allDropboxCheckbox =
              SearchFilterNestedCheckboxService.addNestedCheckbox(
                self.SEARCH_FILTER_SET_NAME,
                COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
                CONTENT_LIBRARY_SOURCES_GROUPS.ALL_DROPBOX,
                allMediaCheckbox,
              );
          }
          allTikTokCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_TIKTOK,
              allMediaCheckbox,
            );
          allYouTubeCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_YOUTUBE,
              allMediaCheckbox,
            );
          allFacebookCheckbox =
            SearchFilterNestedCheckboxService.addNestedCheckbox(
              self.SEARCH_FILTER_SET_NAME,
              COLLECTION_SETTINGS.FILTERS.SOURCES_GROUPS,
              CONTENT_LIBRARY_SOURCES_GROUPS.ALL_FACEBOOK,
              allMediaCheckbox,
            );
        };

        const createNestedCheckboxes = function () {
          createTopLevelNestedCheckboxes();

          const usersState = UsersService.getUsersState();
          usersState.takeUntil(ngUnsubscribe).subscribe(handleUsersStateUpdate);

          const trackedSourcesState =
            TrackedSourcesService.getTrackedSourcesState();
          trackedSourcesState
            .takeUntil(ngUnsubscribe)
            .subscribe(handleTrackedSourcesStateUpdate);

          const instagramAccountsState =
            InstagramAccountsService.getInstagramAccountsState();
          instagramAccountsState
            .takeUntil(ngUnsubscribe)
            .subscribe(handleInstagramAccountsStateUpdate);

          handlePinterestAccountsStateUpdate();

          const filters = new rx.BehaviorSubject({});
          SearchFilterService.getObservableForFilterSet(
            SEARCH_FILTERS.CONTENT_LIBRARY_USERS_DROPDOWN_FILTERS,
          )
            .takeUntil(ngUnsubscribe)
            .subscribe(filters);

          rx.Observable.zip(
            usersState,
            trackedSourcesState,
            instagramAccountsState,
          )
            .take(1)
            .subscribe(() => {
              self.isLoading = false;

              // Don't subscribe to this until data is initialized from tracked sources.
              filters
                .takeUntil(ngUnsubscribe)
                .subscribe(updateSourcesLabelFromFilterUpdate);
            });
        };

        const tearDownCheckboxes = function () {
          ngUnsubscribe.next();
          SearchFilterNestedCheckboxService.clear();
          createNestedCheckboxes();
        };

        self.openSourcesModal = function (filterKey) {
          const modalScope = $scope.$new(true);
          modalScope.filterKey = filterKey;
          modalScope.defaultInstagramAccount = self.defaultInstagramAccount;

          switch (filterKey) {
            case COLLECTION_SETTINGS.FILTERS.CURALATE_USER_IDS: {
              modalScope.filterOptions = self.curalateUsers;
              trackOpenModal('Team Members');
              break;
            }
            case COLLECTION_SETTINGS.FILTERS.TRACKED_USER_IDS: {
              modalScope.filterOptions = self.trackedUsers;
              trackOpenModal('Tracked Users');
              break;
            }
            case COLLECTION_SETTINGS.FILTERS.TRACKED_HASHTAGS: {
              modalScope.filterOptions = self.trackedHashtags;
              trackOpenModal('Tracked Hashtags');
              break;
            }
            default: {
              modalScope.filterOptions = [];
            }
          }

          const modalPromise = $modal.open({
            scope: modalScope,
            template:
              '<sources-modal ' +
              'close="$close(changesApplied)" ' +
              'filter-key="filterKey" ' +
              'filter-options="filterOptions"' +
              'default-instagram-account="defaultInstagramAccount"' +
              '></sources-modal>',
            windowClass: 'pure-bs3 modal-medium source-tree-modal',
          });
          modalPromise.result.then((changesApplied) => {
            if (changesApplied) {
              tearDownCheckboxes();
            }
          });
        };

        self.onPopoverOpen = () => {
          self.focusSearchBar();
          self.isTooltipDisabled = true;
        };

        self.onPopoverClose = () => {
          self.isTooltipDisabled = false;
        };

        self.focusSearchBar = () => {
          const inputBarElement = $element.find(
            '.sources-tree .search-input-container input',
          );
          $timeout(() => {
            inputBarElement.trigger('focus');
          }, 0);
        };

        self.$onInit = function () {
          if (self.initialSources) {
            self.initialState = angular.copy(self.initialSources);
          }
          SearchFilterService.registerNewFilterSet(
            self.SEARCH_FILTER_SET_NAME,
            self.initialState,
          );

          createNestedCheckboxes();
        };

        self.$onDestroy = function () {
          ngUnsubscribe.next();
          ngUnsubscribe.complete();
          SearchFilterNestedCheckboxService.clear();
          SearchFilterService.unregisterFilterSet(self.SEARCH_FILTER_SET_NAME);
        };
      },
    ],
  });
})();
